import React, { useState, useEffect } from 'react';
import PageLoader from '../components/PageLoader';
import { api } from '../App';
import '../styles/AdminBestellingenPage.css';
import beversImg from '../img/speltakteken_bevers.png';
import welpenImg from '../img/speltakteken_welpen.png';
import scoutsImg from '../img/Speltakteken_scouts.png';
import vrijbuitersImg from '../img/speltakteken_vrijbuiters.png';
import explorersImg from '../img/speltakteken_explorers.png';

function AdminBestellingenPage({ user, onBack, onLogout, onSelectSpeltak }) {
  const [speltakken, setSpeltakken] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const getSpeltakImage = (naam) => {
    if (naam === 'bevers') {
      return beversImg;
    } else if (naam === 'welpen') {
      return welpenImg;
    } else if (naam === 'vrijbuiters') {
      return vrijbuitersImg;
    } else if (['verkenners', 'gidsen'].includes(naam)) {
      return scoutsImg;
    } else if (naam === 'explorers') {
      return explorersImg;
    }
    return null;
  };

  useEffect(() => {
    loadSpeltakken();
  }, []);

  const loadSpeltakken = async () => {
    try {
      const response = await api.get('/index.php?action=speltakken');
      setSpeltakken(response.data);
      setLoading(false);
    } catch (err) {
      setError('Fout bij laden van speltakken');
      setLoading(false);
    }
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="admin-bestellingen-container">
      <header className="admin-header">
        <button onClick={onBack} className="back-button">← Terug</button>
        <h1>Bestellingen per speltak</h1>
        <button onClick={onLogout} className="logout-button">Uitloggen</button>
      </header>

      <main className="admin-main">
        <div className="admin-content">
          {error && <div className="error-message">{error}</div>}

          {speltakken.length === 0 ? (
            <div className="no-data">
              <p>Geen speltakken gevonden</p>
            </div>
          ) : (
            <div className="speltakken-grid">
              {speltakken.map((speltak) => (
                <div
                  key={speltak.ID}
                  className="speltak-card"
                  onClick={() => onSelectSpeltak(speltak.ID, speltak.naam)}
                >
                  <img 
                    src={getSpeltakImage(speltak.naam)} 
                    alt={speltak.naam}
                    className="card-image"
                  />
                  <h3>{speltak.naam}</h3>
                  <p className="card-action">Bekijk bestellingen</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default AdminBestellingenPage;
